import type { Checklist, ChecklistItem } from '@cognite/apm-client';
import { useContext, useEffect, useState } from 'react';

import { getShowMarkCompleteModalOnFinishContext } from './use-show-mark-complete-modal-on-finish.context';

type UseShowMarkCompleteModalOnFinishResponse = {
  showMarkCompleteModalOnFinish: boolean;
  setStatusChanged: (statusChanged: boolean) => void;
};

export const useShowMarkCompleteModalOnFinish = (
  completedItemsCount?: number,
  checklistItems?: ChecklistItem[],
  checklist?: Checklist
): UseShowMarkCompleteModalOnFinishResponse => {
  const [statusChanged, setStatusChanged] = useState(false);
  const { useIsChecklistAdminQuery } = useContext(
    getShowMarkCompleteModalOnFinishContext()
  );
  const { data: isChecklistAdmin } = useIsChecklistAdminQuery();

  const showMarkCompleteModalOnFinish: boolean =
    completedItemsCount !== undefined &&
    completedItemsCount === checklistItems?.length &&
    checklist?.status === 'In progress' &&
    statusChanged &&
    Boolean(isChecklistAdmin);

  useEffect(() => {
    return () => {
      setStatusChanged(false);
    };
  }, [checklist?.externalId]);

  return { showMarkCompleteModalOnFinish, setStatusChanged };
};
